export const GOOGLE_RECAPTCHA_SITE_KEY = process.env.GOOGLE_RECAPTCHA_SITE_KEY
export const IS_PROD = process.env.REACT_APP_ENVIRONMENT === 'production'
export const CUSTOM_PROTOCOL_SCHEMA = process.env.CUSTOM_PROTOCOL_SCHEMA